import React from 'react';
import PropTypes from 'prop-types';

import {
  IconNavigationContacts,
  IconNavigationJobs,
  IconNavigationEvents,
  IconNavigationNews,
  IconNavigationCommunities,
  IconNavigationCompanies,
} from '@xingternal/malt-icon';

import { FormattedMessage } from 'react-intl';

import styles from './ExtendedSearchDropdown.css';

const items = {
  contacts: {
    label: 'VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS',
    subSearchLink: 'members',
    icon: IconNavigationContacts,
  },
  jobs: {
    label: 'VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS',
    subSearchLink: 'jobs',
    icon: IconNavigationJobs,
  },
  events: {
    label: 'VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS',
    subSearchLink: 'events',
    icon: IconNavigationEvents,
  },
  news: {
    label: 'VERTICAL_NAVIGATION_HEADER_SEARCH_CONTENT_PAGES',
    subSearchLink: 'news',
    icon: IconNavigationNews,
  },
  communities: {
    label: 'VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES',
    subSearchLink: 'communities',
    icon: IconNavigationCommunities,
  },
  companies: {
    label: 'VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES',
    subSearchLink: 'companies',
    icon: IconNavigationCompanies,
  },
};

const DropdownItems = ({ trigger }) => (
  <ul className={styles.dropdownList}>
    <li className={styles.intro}>
      <FormattedMessage id="SE_EXTENDED_SEARCH_LIST_DESCRIPTION">
        {text => <span className={styles.introText}>{text}</span>}
      </FormattedMessage>
    </li>
    {Object.keys(items).map(function(item, i) {
      const linkItem = items[item];
      const IconElement = linkItem.icon;
      return (
        <li className={styles.item} key={i}>
          <button
            className={styles.itemButton}
            onClick={() => trigger(linkItem.subSearchLink)}
          >
            <IconElement className={styles.icon} />

            <FormattedMessage id={linkItem.label}>
              {text => <span className={styles.itemText}>{text}</span>}
            </FormattedMessage>
          </button>
        </li>
      );
    })}
  </ul>
);

DropdownItems.displayName = 'DropdownItems';

DropdownItems.propTypes = {
  trigger: PropTypes.func.isRequired,
};

export default DropdownItems;
